export enum PortTariffLineVesselProperties {
  NONE = 'none',
  LOA = 'loa',
  BEAM = 'beam',
  GRT = 'grt',
  NRT = 'nrt',
  DWT = 'dwt',
}
